import styled, { css } from 'styled-components';
import { themeColor, themeSize } from '../../../theme/getters';
import { H2, nonResponsiveSmallSpacedHeading, paragraph } from '../../../theme/typography';
import { columnLayout, Content as ContentLayout } from '../../../theme/layout';
import { LazyLoadImage } from '../../../shared/components/lazyLoadImage';
import { media } from '../../../theme/media';

export const Container = styled.section`
  width: 100%;
  background: ${themeColor('secondaryBlue')};
  ${media.tablet`
    padding-top: 32px;
    padding-bottom: 80px;
  `};
`;

export const Content = styled(ContentLayout)`
  padding: 56px ${themeSize('contentPadding')}px;
  ${media.tablet`
    padding: 0 ${themeSize('contentPadding')}px;
    ${columnLayout};
  `};
`;

export const ImageCell = styled.div`
  position: relative;
`;

export const ImageWrapper = styled.div`
  display: block;
  max-width: 380px;
  margin: auto;
  box-sizing: content-box;
  padding: ${themeSize('contentPadding')}px;
`;

export const Image = styled(LazyLoadImage).attrs(() => ({
  imgStyle: css`
    object-fit: cover;
    height: 100%;
    border-radius: 50%;
  `,
  placeholderStyle: css`
    padding-top: 100%;
  `,
}))`
  overflow: hidden;
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  object-fit: cover;
  border-radius: 50%;
`;

export const TextWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-top: 56px;

  ${media.tablet`
    flex: 1;
    padding-right: 56px;
    padding-bottom: 56px;
  `}
`;

export const Title = styled(H2)`
  text-align: left;
  margin-bottom: 24px;
  margin-top: 0;

  ${media.tablet`
    font-size: 45px;
    line-height: 53px;
  `};
`;

export const Text = styled.p`
  ${paragraph};
  text-align: left;
  margin: 0;
`;

export const SectionTitle = styled.h2`
  ${nonResponsiveSmallSpacedHeading};
  margin-bottom: 24px;
  text-align: left;
  ${media.tablet`
    text-align: center;
    margin-bottom: 32px;
  `};
`;
